const endpoints = require('endpoint/endpoint-constant.js');
const ExceptionService = require('exceptions/exception-service.js');
const reqwest = require('reqwest/reqwest.min');
const Q = require('q');

const TrustpilotService = (function(root, doc, undefined) {

    const filename = 'trustpilot-service.js';
    const trustpilotConfig = {
        ApiKey: 'wnZ9pkx3ZYlFVrajL6Yp1D0lgUPzuQCw',
        businessId: '498836a3000064000504150d'
    };

    const logError = (message, data = {}) => {
        ExceptionService.handle('warning', { filename, message, data });
    };


    /**
     * Query trustpilot rating info
     */
    const getBusinessInfo = (id) => {
        let url = endpoints.absoluteEndpoints.trustpilotBusinnessInfo;
        url = url.replace('{businessId}', trustpilotConfig.businessId);

        let deferred = Q.defer();

        const onSuccess = (response) => {
            if (response) {
                deferred.resolve(response);
            } else {
                onError({
                    message: 'bad response format',
                    error: response
                });
            }
        };

        const onError = (error) => {
            logError('getBusinessInfo(), Something went wrong', error);
            deferred.reject(error);
        };

        reqwest({ url: url, method: 'GET', headers: { ApiKey: trustpilotConfig.ApiKey } })
            .then(onSuccess).catch(onError);
        return deferred.promise;
    };

    /**
    * Get trustpilot starts string (great, excellent etc)
    */
    const getStarsString = (stars) => {
        let url = endpoints.absoluteEndpoints.trustpilotStarString;
        url = url.replace('{stars}', stars);

        let deferred = Q.defer();

        const onSuccess = (response) => {
            if (response) {
                deferred.resolve(response);
            } else {
                onError({
                    message: 'bad response format',
                    error: response
                });
            }
        };

        const onError = (error) => {
            logError('getStarsString(), Something went wrong', error);
            deferred.reject(error);
        };

        reqwest({ url: url, headers: { ApiKey: trustpilotConfig.ApiKey } })
            .then(onSuccess).catch(onError);
        return deferred.promise;
    };

    return {
        getBusinessInfo,
        getStarsString
    };

})(window, document);

module.exports = TrustpilotService;
